import { useCallback, useEffect, useRef } from "react";
import debounce from "lodash/debounce";
// highly inspired by https://github.com/gnbaron/use-lodash-debounce/blob/master/src/use-debounce.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = (callback, delay = 0, options) => {
    const callbackRef = useRef(callback);
    const debouncedCallback = useCallback(debounce(((...args) => callbackRef.current(...args)), delay, options), [
        delay,
        options,
    ]);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    // on unmount it cancels the debounced function
    useEffect(() => debouncedCallback.cancel, [debouncedCallback]);
    return debouncedCallback;
};
//# sourceMappingURL=useDebounceCallback.js.map